<template>
  <div class="container">
    <div class="header_1">
      <div class="img2_box flexSt">
        <img
          class="img5"
          src="https://hubei-41.zos.ctyun.cn/ss2405/resource/堂堂网智慧新体育LOGO.白色.fw.png"
          alt=""
        />
      </div>
    </div>
    <img
      class="img3"
      src="https://sisheng-resource.oss-cn-shenzhen.aliyuncs.com/newlogin20240624.png"
      alt=""
    />
    <div class="info_box">
      <div class="info_box_a">
        <div class="flexSc title">系统登录</div>
        <div class="flexSt dadadad">
          <div class="titlewwww">登录身份：</div>
          <el-radio-group v-model="radio">
            <el-radio :label="0">教育局</el-radio>
            <el-radio :label="1">学校</el-radio>
            <el-radio :label="2">教师</el-radio>
          </el-radio-group>
        </div>
        <el-form
          label-position="top"
          ref="form"
          :rules="rules"
          :hide-required-asterisk="true"
          label-width="80px"
          :model="form"
        >
          <el-form-item label="" prop="username">
            <el-input
              class="inp"
              placeholder="登录账号"
              prefix-icon="el-icon-mobile-phone"
              v-model="form.username"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="" prop="password">
            <el-input
              class="inp"
              placeholder="密码"
              v-model="form.password"
              prefix-icon="el-icon-lock"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item label="" prop="code">
            <el-input
              class="inp"
              placeholder="验证码"
              v-model="form.code"
              prefix-icon="el-icon-circle-check"
            >
              <template slot="append">
                <div
                  @click="refreshCode()"
                  class="code"
                  style="cursor: pointer"
                >
                  <s-identify
                    :identifyCode="identifyCode"
                  ></s-identify></div></template
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-button class="btn" type="primary" @click="login"
              >登录</el-button
            >
          </el-form-item>
        </el-form>
      </div>

      <div class="tip flexSt">
        <div>
          <div
            @click="handleOpen('https://beian.miit.gov.cn/#/Integrated/index')"
          >
            Copyright © 2024 hneav.com All Rights Reserved. 
            湖南教育音像电子出版社有限责任公司 湘ICP备12008311号-6
          </div>

          <div class="flexSc">
            <div class="flexSc">
              <img src="../assets/img/219.png" alt="" />
              湘公网安备 43010502001025号
            </div>

            <a href="javaScript:void\(0\)">投诉举报</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import sIdentify from "./sIdentify/sIdentify";
export default {
  components: {
    sIdentify,
  },
  data() {
    const checkFinanceCode = (rule, value, callback) => {
      if (value) {
        // var reg =
        //   /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F])[\da-zA-Z\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F]{8,}$/;

        var reg =
          /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F])[\da-zA-Z\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F]{8,}$/;
        if (reg.test(value) === false) {
          callback(new Error("密码至少为8位,包含数字、大小写字母以及特殊字符"));
        } else {
          callback();
        }
      } else {
        callback(new Error("请输入密码"));
      }
    };

    return {
      identifyCode: "",
      identifyCodes: [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "a",
        "b",
        "c",
        "d",
      ], //根据实际需求加入自己想要的字符
      form: {
        username: "",
        password: "",
        code: "",
      },
      checked: false,
      rules: {
        username: [
          // required: 非空规则
          // message: 提示信息
          // trigger: 触发的方式  blur  change
          { required: true, message: "请输入登录账号", trigger: "blur" },
        ],
        password: [
          // { required: true, message: "请输入密码", trigger: "blur" },
          // {
          //   // min: 6,
          //   // max: 12,
          //   // message: "长度在 6 到 12 个字符",
          //   trigger: "change",
          // },

          // {
          //   min: 8,
          //   message: "密码至少为8位,包含数字、大小写字母以及特殊字符",
          //   trigger: "change",
          //   validator: checkFinanceCode,
          // },
          // {
          //   required: true,
          //   message: "密码至少为8位,包含数字、大小写字母以及特殊字符",
          //   trigger: "blur",
          //   validator: checkFinanceCode,
          // },
          {
            required: true,
            message: "请输入密码",

            trigger: "blur",
          },
        ],
        code: {
          required: true,
          message: "请输入验证码",

          trigger: "blur",
        },
      },
      radio: 0,
    };
  },
  mounted() {
    this.setRem();
    this.watchResize();
    this.refreshCode();
  },
  methods: {
    setRem() {
      // 基于 1920px 宽度的屏幕
      const designWidth = 1920;
      // 你设定的基准，100px 对应 1rem
      const baseFontSize = 100;
      // 获取当前视口宽度
      const viewportWidth = document.documentElement.clientWidth;
      console.log(viewportWidth, "viewportWidth");
      // 计算 rem 值，这里我们简单地将设计稿宽度除以视口宽度，再乘以基准字体大小
      const rem = (viewportWidth / designWidth) * baseFontSize;
      // 设置根元素的 font-size
      document.documentElement.style.fontSize = `${rem}px`;
    },
    watchResize() {
      const _this = this;
      window.addEventListener("resize", function () {
        _this.setRem();
      });
    },
    handleOpen(url) {
      window.open(url);
    },
    async login() {
      if (this.radio == 1) {
        this.axios.defaults.baseURL = "https://sports.hneav.com/school/api";
      } else if (this.radio == 2) {
        this.axios.defaults.baseURL = "https://sports.hneav.com/teacher/api";
      } else if (this.radio == 0) {
        this.axios.defaults.baseURL = "https://sports.hneav.com/jyj/api";
      }
      // if (this.handleChaecPwd(this.form.password)) {
      try {
        await this.$refs.form.validate();
        if (this.form.code.toLowerCase() != this.identifyCode.toLowerCase()) {
          return this.$message({
            message: "验证码不一致",
            type: "warning",
            customClass: "fz-16",
          });
        }
        console.log(this.axios.baseURL, "=baseURL");
        let url = this.radio == 2 ? "/auth/web/login" : "/auth/login";
        const res = await this.axios.post(url, {
          row: { ...this.form },
        });
        console.log(res);
        if (res.code === 1) {
          localStorage.setItem("token", res.data.token);
          const user = this.radio == 2 ? res.data.user : res.data.admin;
          localStorage.setItem("user", JSON.stringify(user));
          localStorage.setItem(
            "aliyun_oss",
            JSON.stringify(res.data.aliyun_oss)
          );
          localStorage.setItem("ctyun_oss", JSON.stringify(res.data.ctyun_oss));
          if (this.radio == 1) {
            window.open("https://sports.hneav.com/school/indexnew");
          } else if (this.radio == 2) {
            window.open("https://sports.hneav.com/teacher/index");
          } else if (this.radio == 0) {
            window.open("https://sports.hneav.com/jyj/indexnew");
          }
        } else {
          this.$message({
            message: res.msg,
            type: "error",
            customClass: "fz-16",
          });
        }
      } catch (e) {
        return false;
      }
      // } else {
      //   this.$message.warning("密码至少为8位,包含数字、大小写字母以及特殊字符");
      // }
    },
    randomNum(min, max) {
      max = max + 1;
      return Math.floor(Math.random() * (max - min) + min);
    },
    // 更新验证码
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    // 随机生成验证码字符串
    makeCode(data, len) {
      for (let i = 0; i < len; i++) {
        this.identifyCode +=
          this.identifyCodes[this.randomNum(0, this.identifyCodes.length - 1)];
      }
    },
    handleChaecPwd(val) {
      let finalCheckPwd =
        // /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,16}$/;
        /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F])[\da-zA-Z\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F]{8,}$/;

      return finalCheckPwd.test(val);
    },
  },
};
</script>
<style lang="less" scoped>
.container {
  background: linear-gradient(135deg, #020d23 0%, #104066 72%);
  border-radius: 0px 0px 0px 0px;
  width: 100%;
  height: 100%;
  position: relative;
  .dadadad {
    margin-bottom: 24px;
  }
  .img5 {
    // width: 6rem;
    height: 0.65rem;
    width: auto;
  }
  .titlewwww {
    font-size: 14px;
    margin-right: 8px;
  }
  .header_1 {
    width: 100%;
    font-size: 0.5rem;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    color: #3c7dff;
    z-index: 999;
    position: absolute;
  }
  .img1 {
    // width: 320px;
    // height: 39px;
    // margin-left: 251px;
    width: 20%;
    // height: 39px;
  }
  .img2_box {
    // margin-left: 98px;
    // margin-top: 10px;
    // min-width: 500px;
    margin-left: 3.59rem;
    // margin-top: 2.12rem;
    margin-top: 1.92rem;
  }
  .img2 {
    width: 1.19rem;
    height: 0.69rem;
    margin-right: 0.24rem;
    // width: 3%;
  }
  .img3 {
    // width: 70%;
    position: absolute;
    // bottom: 0;
    // left: 0;
    margin-left: 2.86rem;
    width: 6.56rem;
    height: 4.92rem;
    // margin-top: 3.51rem;
    margin-top: 2.9rem;
  }
  .info_box {
    position: absolute;
    right: 2.51rem;
    // right: 10%;
    // top: 18%;
    top: 2.52rem;
    width: 4.1rem;
    min-width: 3.5rem;
    .info_box_a {
      background: #ffffff;
      box-shadow: 0px 0.03rem 0.12rem 0.01rem rgba(161, 189, 255, 0.34);
      border-radius: 0.3rem;
      padding: 0.39rem 0.46rem 0.56rem 0.46rem;
      box-sizing: border-box;
    }
    // width: 569px;
    // height: 680px;

    .title {
      font-size: 0.34rem;
      font-weight: 600;
      color: #005bad;
      margin-bottom: 0.32rem;
    }
    .inp {
      // font-size: 20px;
      font-size: 0.2rem;
      color: #ffffff;
    }
    /deep/.el-input__prefix {
      font-size: 0.26rem;
      // padding: 19px;
    }
    /deep/.el-input--prefix {
      .el-input__inner {
        padding-left: 0.41rem;
        color: #989898;
      }
    }
    .code {
      width: 1.11rem;
      height: 0.38rem;
    }
    /deep/.el-input-group__append {
      padding: 0;
    }
    /deep/.el-checkbox__label {
      font-size: 0.2rem;
    }
    /deep/.el-checkbox__inner {
      width: 0.21rem;
      height: 0.21rem;
    }
    /deep/.el-checkbox__input {
      line-height: 2;
    }
    /deep/.el-checkbox__inner::after {
      top: 0.04rem;
      left: 0.08rem;
    }
    .btn {
      background: #50a6ff;
      border-radius: 0.1rem;
      width: 100%;
      font-size: 0.22rem;
    }
  }
  // .tip {

  //   margin-top: 30px;
  //   font-size: 17px;
  //   font-family: Microsoft YaHei, Microsoft YaHei;
  //   font-weight: 400;
  //   color: #b2b2b2;
  //   text-align: center;
  //   cursor: pointer;
  // }
  .tip {
    margin-top: 0.3rem;
    font-size: 0.17rem;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    text-align: center;
    cursor: pointer;
    a {
      color: #ffffff;
      margin-left: 0.1rem;
    }
    a:hover {
      color: #3c7dff;
    }
    img {
      width: 0.18rem;
      height: 0.2rem;
      margin-right: 0.1rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue